import { render, staticRenderFns } from "./AnchoredCallout.vue?vue&type=template&id=10e76d38&scoped=true"
import script from "./AnchoredCallout.vue?vue&type=script&lang=js"
export * from "./AnchoredCallout.vue?vue&type=script&lang=js"
import style0 from "./AnchoredCallout.vue?vue&type=style&index=0&id=10e76d38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e76d38",
  null
  
)

export default component.exports